/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import { Toast } from 'vant'
import { hex_md5 } from './md5'

/**
 * 提示函数
 */
const tip = (msg) => {
  Toast({
    duration: 3000, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    message: msg,
  })
}

/**
 * 请求失败后的错误统一处理 请求成功除200外的处理
 * @param {Number} status 请求失败的状态码
 * @param {String} other 请求失败的描述
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 404:
      tip('请求的资源不存在')
      break
  }
}

// 创建axios实例

const appkey = '10001'
const appSecret = 'ZEKumsH45xXUAymYaOgLQt9qL9OJJbhn'
const data = new Date()
const month =
  data.getMonth() + 1 >= 10 ? data.getMonth() + 1 : `0${data.getMonth() + 1}`
const day = data.getDate() >= 10 ? data.getDate() : `0${data.getDate()}`
const hours = data.getHours() >= 10 ? data.getHours() : `0${data.getHours()}`
const minutes =
  data.getMinutes() >= 10 ? data.getMinutes() : `0${data.getMinutes()}`
const seconds =
  data.getSeconds() >= 10 ? data.getSeconds() : `0${data.getSeconds()}`
const timestamp = `${data.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`
const sign = hex_md5(
  `${appSecret}timestamp${timestamp}${appSecret}`
).toUpperCase()

var instance = axios.create({
  timeout: 1000 * 12,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    appkey: appkey,
    timestamp: timestamp,
    sign: sign,
  },
  locationHost: '',
  extStarMomHostName: '',
})

// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/json'

// 环境的切换
if (process.env.NODE_ENV == 'local') {
  instance.defaults.baseURL = 'https://momuat.feihe.com/xmh/v2'
  instance.harvardBaseURL = 'https://momuat.feihe.com/comments/v1'
  instance.locationHost = 'https://momuat.feihe.com'
  instance.extStarMomHostName = process.env.VUE_APP_EXTSTARBASEURL
} else {
  //禁止在外置浏览器打开
  let ua = navigator.userAgent.toLowerCase()
  let isWeixin = ua.indexOf('micromessenger') != -1
  let allowlink = [
    '/donationMilkApp',
    '/donationMilkApp/userInfoApp',
    '/promotionMilk',
  ]
  // if (!isWeixin) {
  //   if(allowlink.indexOf(window.location.pathname) == -1){
  //     window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888"
  //   }
  // }
  instance.defaults.baseURL = '/xmh/v2'
  instance.harvardBaseURL = window.location.origin + '/comments/v1'
  instance.locationHost = window.location.origin
  instance.extStarMomHostName = process.env.VUE_APP_EXTSTARBASEURL
}

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) =>
    res.status === 200
      ? Promise.resolve(res)
      : errorHandle(res.status, res.statusText),
  // 请求失败
  (error) => {
    const { response } = error
    if (error.message.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout
      // tip("活动太火爆了");
      return Promise.reject(error)
    } else {
      if (response) {
        // 请求已发出，但是不在2xx的范围
        errorHandle(response.status, response.statusText)
        return Promise.reject(response)
      } else {
        // 处理断网的情况
        if (!window.navigator.onLine) {
          tip('网络连接超时，请检查网络')
        } else {
          return Promise.reject(error)
        }
      }
    }
  }
)

/**
 * 对象拼接在url上
 * @param {String} url [请求的url地址]
 * @param {Object} param [url携带的参数]
 */
const createURL = (url, param) => {
  var urlLink = ''
  if (Object.keys(param).length != 0) {
    for (var key in param) {
      urlLink += '&' + key + '=' + param[key]
    }
    var flag = url.indexOf('?') > -1
    if (flag) {
      urlLink = url + urlLink
    } else {
      urlLink = url + '?' + urlLink.substr(1)
    }
  } else {
    urlLink = url
  }
  return urlLink
}

export default {
  hostName: instance.locationHost,
  extStarMomHostName: instance.extStarMomHostName,
  harvardBaseURL: instance.harvardBaseURL,
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   * @param {Function} callback [回调函数]
   */
  get(url, params, callback, catchCallback, type) {
    type === 'member' &&
      (instance.defaults.baseURL =
        process.env.VUE_APP_APIBASEURL + '/xmh/member')
    return instance
      .get(url, {
        params: params,
      })
      .then((res) => {
        callback(res.data)
      })
      .catch((res) => {
        if (catchCallback) catchCallback(res)
      })
  },
  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} paramsUrl [url携带的参数]
   * @param {Object} params [请求时携带的参数]
   * @param {Function} callback [回调函数]
   */
  post(url, paramsUrl, params, callback, catchCallback, type) {
    type === 'member' &&
      (instance.defaults.baseURL =
        process.env.VUE_APP_APIBASEURL + '/xmh/member')
    return instance
      .post(createURL(url, paramsUrl), params)
      .then((res) => {
        callback(res.data)
      })
      .catch((res) => {
        if (catchCallback) catchCallback(res)
      })
  },
}
